import axios from 'axios'

import { storageGet, storageRemove, storageSet } from "../Collector/StorageAction";
import { cookieGet } from '../Collector/CookieAction';
import { LogoutReducer, RefershLoginReducer, SetLoading } from '../../Components/LoginForm/Reducer/LoginReducer';

import { baseURLs } from './Config';

let store;
let isRefreshing = false;
let failedQueue = []; 

const processQueue = (error, token = null) => {
    failedQueue.forEach((promise) => {
        if (token) {
            promise.resolve(token);
        } else {
            promise.reject(error);
            
        }
    });

    failedQueue = [];
};

const api = axios.create();

export const injectStore = _store => {
    store = _store;
};

// Request interceptor
api.interceptors.request.use(
    (config) => {
        const service = Object.keys(baseURLs).find(key => config.url.startsWith(`/${key}`));

        if (service) {
            config.baseURL = baseURLs[service];
            // Backend route'ları gerçekten /Admin/ ile başlıyor — sadece /User
            // prefix'ini soyuyoruz; /Admin URL'de kalsın.
            if (service === 'User') {
                config.url = config.url.replace(`/${service}`, '');
            }
        }

        // Tarayıcı /Admin/* sayfasındaysa admin oturumu — /User/... uçlarında bile adminToken yolla
        const isAdminPath = typeof window !== 'undefined'
            && window.location?.pathname?.startsWith('/Admin');
        const isAdmin = service === 'Admin' || isAdminPath;
        const tokenKey = isAdmin ? 'adminToken' : 'token';
        const token = storageGet(tokenKey);
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        config.__isAdmin = isAdmin;

        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        const isAdmin = !!originalRequest?.__isAdmin;

        if (typeof error.response !== "undefined") {
            const refreshTokenKey = isAdmin ? 'adminRefreshToken' : 'refreshToken';
            const tokenKey        = isAdmin ? 'adminToken'        : 'token';
            const refreshToken    = storageGet(refreshTokenKey);

            if (
                refreshToken &&
                error.response.status === 401 &&
                !originalRequest._retry
            ) {
                originalRequest._retry = true;

                if (isRefreshing) {
                    return new Promise((resolve, reject) => {
                        failedQueue.push({ resolve, reject });
                    })
                    .then((token) => {
                        originalRequest.headers['Authorization'] = `Bearer ${token}`;
                        return api(originalRequest);
                    })
                    .catch(err => Promise.reject(err));
                }

                isRefreshing = true;

                try {
                    const refreshUrl = isAdmin
                        ? `${baseURLs.Admin}/Admin/RefreshToken`
                        : `${baseURLs.User}/Login/RefreshToken`;
                    const data = isAdmin
                        ? { refreshToken }
                        : {
                            clientId: storageGet("clientId"),
                            activityId: storageGet("activityId"),
                            csrf: cookieGet("csrf"),
                            refreshToken,
                        };

                    const res = await axios.post(refreshUrl, data);

                    if (res.status === 200 && res.data.payload.status) {
                        const newToken = isAdmin
                            ? res.data.payload.token
                            : res.data.payload.data.token;
                        storageSet(tokenKey, newToken);
                        processQueue(null, newToken);
                        originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
                        return api(originalRequest);
                    } else {
                        processQueue(new Error('Token yenileme başarısız'), null);
                        storageRemove(tokenKey);
                        storageRemove(refreshTokenKey);
                        if (isAdmin) {
                            window.location.href = '/AdminLogin';
                        } else {
                            store.dispatch(LogoutReducer());
                        }
                    }
                } catch (err) {
                    processQueue(err, null);
                    storageRemove(tokenKey);
                    storageRemove(refreshTokenKey);
                    if (isAdmin) {
                        window.location.href = '/AdminLogin';
                    } else {
                        store.dispatch(LogoutReducer());
                    }
                } finally {
                    isRefreshing = false;
                }
            } else if (error.response.status === 402) {
                storageRemove(tokenKey);
                storageRemove(refreshTokenKey);
                if (isAdmin) window.location.href = '/AdminLogin';
                else store.dispatch(LogoutReducer());
            }
        }

        return Promise.reject(error);
    }
);

export const getRefreshPageCheckToken = () => {
    let refreshToken = storageGet("refreshToken");
    store.dispatch(SetLoading());

    if (typeof refreshToken !== "object" && refreshToken) {
        const data = {
            clientId: storageGet("clientId"),
            activityId: storageGet("activityId"),
            csrf: cookieGet("csrf"),
            refreshToken: refreshToken
        };

        return axios.post(`${baseURLs.User}/Login/RefreshToken`, data).then((res) => {
            if (res.status === 200 && res.data.payload.status) {
                store.dispatch(RefershLoginReducer(res.data.payload));
            } else {
                storageRemove("token");
                storageRemove("refreshToken");
                store.dispatch(LogoutReducer());
            }
        }).catch(() => {
            storageRemove("token");
            storageRemove("refreshToken");
            store.dispatch(LogoutReducer());
        });
    }
};

export default api;


